/** @format */
import { Injectable, InjectionToken } from '@angular/core';
import { OtmId } from 'common-typescript/types';
import { SessionStorageService } from 'sis-common';

// Should be same as in planSeeker.js
export const SELECTED_PLAN_ID_STORAGE_KEY = 'otm.student.uiContext.planId';

export const SELECTED_PLAN_STORE_SERVICE_INJECTION_TOKEN = new InjectionToken<SelectedPlanStoreService>('SelectedPlanStoreService');

@Injectable({
    providedIn: 'root',
})
export class SelectedPlanStoreService {
    private readonly sessionStorageService: SessionStorageService;

    constructor(sessionStorageService: SessionStorageService) {
        this.sessionStorageService = sessionStorageService;
    }

    setSelectedPlanId(planId: OtmId): void {
        this.sessionStorageService.setValue(SELECTED_PLAN_ID_STORAGE_KEY, planId);
    }

    getSelectedPlanId(): OtmId | null {
        return this.sessionStorageService.getValueOrDefault<null | string>(SELECTED_PLAN_ID_STORAGE_KEY, null);
    }
}
